import { z } from 'zod';
import { ReportRunScopeSchema } from './report-run.schema.js';

export const DocumentReportRunRequestSchema = z.object({
    profile: z.object({
        id: z.string().trim().min(1).max(80),
        expectedVersion: z.number().int().positive().optional(),
    }).strict(),
    scope: ReportRunScopeSchema,
    locale: z.enum(['tr', 'en']).optional(),
}).strict();

/**
 * A document can run a report only when the document screen can supply every
 * required selector and a usable scope without pretending the document is an
 * unrelated source record.
 */
export function reportDefinitionSupportsDocumentBinding(definition) {
    if (!definition?.lifecycle?.runEnabled || definition.capabilities?.profile !== true) return false;

    const scopeModes = new Set(definition.scopeModes || []);
    const requiredSelectors = definition.selectorSchema?.required || [];
    const hasSupportedScope = definition.domainKey === 'document'
        ? scopeModes.has('filtered')
            || scopeModes.has('selected')
            || scopeModes.has('single')
            || (scopeModes.has('tenant') && requiredSelectors.some((key) => ['documentId', 'recordId'].includes(key)))
        : scopeModes.has('tenant') || scopeModes.has('filtered');
    if (!hasSupportedScope) return false;

    const defaults = definition.selectorDefaults || {};
    return requiredSelectors.every((key) => (
        (Object.hasOwn(defaults, key) && defaults[key] != null && defaults[key] !== '')
        || (definition.domainKey === 'document' && ['documentId', 'recordId'].includes(key))
    ));
}
